"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxCell = void 0;
const react_1 = require("react");
const inline_table_field_cells_1 = require("../../../components/inline-table-field/inline-table-field-cells");
function CheckboxCell({ collectionDatakey, ...props }) {
    const Cell = inline_table_field_cells_1.InlineTableFieldCells.useInlineCheckboxFactory({
        ...props,
        collectionDatakey,
    });
    return (0, react_1.useMemo)(() => Cell, [collectionDatakey]);
}
exports.CheckboxCell = CheckboxCell;
//# sourceMappingURL=checkbox-cell.js.map